import React from 'react';
import { Button, Icon } from '@/components/common';
import type { AppNotification } from '../../types';
import { buildNotificationRoute } from '../../utils/notification-routing';

interface Props {
  notification: AppNotification;
  onNavigate?: (path: string) => void;
}

export const ImportCompleteCard: React.FC<Props> = ({ notification, onNavigate }) => {
  const status = notification.payload?.status as string | undefined;
  const isPartial = status === 'partial';

  const handleClick = () => {
    const route = buildNotificationRoute(notification);
    if (route) onNavigate?.(route);
  };

  return (
    <Button onClick={handleClick} variant="plain" size="none" className="text-left w-full justify-start">
      <div className="flex items-center gap-1 mt-0.5">
        <Icon
          name={isPartial ? 'warning' : 'task_alt'}
          size="xs"
          className={isPartial ? 'text-amber-500' : 'text-emerald-500'}
        />
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {isPartial ? 'Finished with issues' : 'Import complete'}
        </p>
      </div>
    </Button>
  );
};
